export default "* Trækbåre\n* Knob\n* Redskab";